export const FALLBACK_COLOR_NEUTRAL = '#44505E';
